import React, { Fragment } from 'react';
import { observer } from 'mobx-react';
import { ThemedButton } from '@awarego-ui/components';
import { CircularProgress } from '@mui/material';

function ReportFormFooter({
    reportsForm,
    submitText = 'Save',
    creatingReport,
    onCancel,
    onSubmit,
}) {
    return (
        <Fragment>
            {creatingReport ? <CircularProgress size={20} /> : null}
            <ThemedButton
                text={'Cancel'}
                mode={'secondary'}
                disabled={creatingReport}
                onClick={onCancel}
            />
            <ThemedButton
                text={submitText}
                mode={'primary'}
                disabled={!reportsForm.isValid || creatingReport}
                onClick={onSubmit}
            />
        </Fragment>
    );
}

export default observer(ReportFormFooter);
